const isObject = (v) => v !== null && typeof v === 'object'

// The value of a form field `name` ("key" or "key.subKey", the dotted form reaching into an object value) from the form's changed data,
// else its initial data, else null. Data that is not an object (a record that came as a plain string, a nested value that is not an
// object) has no fields to read, so it is skipped instead of throwing.
export const readFieldValue = (changedData, initialData, fieldName) => {
  const [key, subKey] = fieldName.split('.')
  const read = (data) => (subKey ? (isObject(data[key]) ? data[key][subKey] : undefined) : data[key])
  if (isObject(changedData) && key in changedData) return read(changedData)
  if (isObject(initialData) && key in initialData) return read(initialData)
  return null
}
